// extracted by mini-css-extract-plugin
export default {"title":"E--z","warning":"F--z","sizeOptionsLegendText":"G--z"};